import React, { useMemo, useState } from "react";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import ConsultaForm from "./ConsultaFormulario";

import Agente from "../assets/software/ThefClien4.8.exe";
import imgVerAgente from "../assets/img/veragente.png";
import imgServidor from "../assets/img/cambiardirservidor.jpg";

// === Recursos "Sponsor"
const URL_VIDEO_INTRO    = "https://www.youtube.com/embed/qF_yjzG52Mk?si=fxGtkZ9SpnYzpufi"; // intro Sponsor/Nación
const URL_VIDEO_DESC_AGT = "https://www.youtube.com/embed/LQtBOiJ50qU?si=oGMUkmZ-6B8DiMrO"; // descargar agente

export default function Sponsor({
  apiUrl   = "https://pjb.edu.ar/api/desbloqueos_v2/index.php",
  apiToken = "a3f19c8e2b7d4f6a1c0e5b9d7a2f3c8e6d1b4a7f9e2c5d0b8a6c3e1f7d4b2aa9",
}) {
  // --- estado principal
  const [hwid, setHwid] = useState("");
  const [bootTick, setBootTick] = useState("");
  const [status, setStatus] = useState("idle"); // idle | loading | success | error
  const [codigo, setCodigo] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [httpStatus, setHttpStatus] = useState(null);
  const [debug, setDebug] = useState(null);

  const [saveStatus, setSaveStatus] = useState("idle"); // idle | saving | saved | error
  const [saving, setSaving] = useState(false);
  const [savedId, setSavedId] = useState(null);

  const [formError, setFormError] = useState("");

  // Sección “agente”
  const [showAgente, setShowAgente] = useState(false);

  // Auth opcional (para precargar datos del usuario en el formulario)
  const { accounts } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const userEmail = isAuthenticated ? (accounts[0]?.username || accounts[0]?.idTokenClaims?.email || "") : "";
  const userName  = isAuthenticated ? (accounts[0]?.name || "") : "";
  const userSub   = isAuthenticated ? (accounts[0]?.homeAccountId || accounts[0]?.localAccountId || "") : "";
  const [nombre, apellido] = (userName || "").trim().split(/\s+/, 2);

  // helpers
  const tokenMissing = useMemo(() => !apiToken || apiToken === "", [apiToken]);
  const sanitizeHWID = (v) => v.replace(/\s+/g, "").toUpperCase();
  const isHex = (v) => /^[0-9A-F]+$/.test(v);
  const isFormReady = hwid.trim() !== "" && String(bootTick).trim() !== "";

  
  const pickUiMessage = (json, fallback) => {
    if (json && typeof json === "object") {
      if (json.ui_message) return json.ui_message;
      if (json.message) return json.message;
      if (json.error && typeof json.error === "object") {
        if (json.error.ui_message) return json.error.ui_message;
        if (json.error.message)     return json.error.message;
      }
      if (json.data && json.data.codigo === null && json.error?.message) {
        return json.error.message;
      }
    }
    return fallback;
  };

  const validate = () => {
    const hw = sanitizeHWID(hwid);
    const bt = String(bootTick).trim();

    if (!hw || !bt)        { setFormError("Ingresá HWID y Boot Tick."); return false; }
    if (hw.length > 128 ||
        bt.length > 128)   { setFormError("Parámetros demasiado largos."); return false; }
    if (!isHex(hw))        { setFormError("El HWID debe ser hexadecimal (0-9, A-F), sin guiones ni espacios."); return false; }

    setFormError("");
    return true;
  };

const checkExisting = async (hw, bt) => {
  try {
    const res = await fetch("https://pjb.edu.ar/api/desbloqueos_v2/check_consulta.php", {
      method: "POST",
      headers: {
        "Authorization": `Bearer ${apiToken}`,
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ 
        hwid: hw, 
        bootTick: bt 
      }),
    });

    const json = await res.json();

    if (json.success && json.found && json.data) {
      const { id, estado, mensaje, motivos } = json.data;
      const idCaso = id ? `#${id}` : "";

      // 1. Mapeo único: solo traducimos NO_SECRET. 
      // CONTROLADO y los demás mostrarán su nombre original de la DB.
      const mapeoEstados = { "NO_SECRET": "SOLICITUD RECIBIDA" };
      const estadoVisible = mapeoEstados[estado] || estado;

      // 2. CONTROLADO se suma a la lista de bloqueo para que el usuario no duplique la carga
      const estadosGestion = ["NO_SECRET", "ENVIADO", "VALIDO", "CONSULTA", "PROCESANDO", "CONTROLADO"];

      if (estadosGestion.includes(estado)) {
        
        let titulo = "¡Solicitud en Proceso!";
        let textoPrincipal = "Tu pedido ya se encuentra en nuestro sistema y está siendo gestionado.";
        let alertClass = "alert-info";

        // Personalización por estado
        if (estado === "NO_SECRET") {
          titulo = "Gestión Iniciada";
          textoPrincipal = "Hemos recibido tus datos correctamente. Actualmente estamos validando la información.";
          alertClass = "alert-light border-info";
        } else if (estado === "CONTROLADO") {
          // Mensaje específico para cuando el equipo ya fue revisado pero no enviado
          titulo = "Revisión Finalizada";
          textoPrincipal = "Tu equipo ya ha sido controlado por el equipo técnico. Pronto recibirás novedades.";
          alertClass = "alert-info border-primary";
        }

        const htmlMotivos = (motivos && motivos.length > 0) 
          ? `<div class="d-none mt-2 small text-muted"><b>Nota técnica:</b><ul class="mb-0 text-start">${motivos.map(m => `<li>${m}</li>`).join('')}</ul></div>` 
          : '';

        setMensaje({
          html: `
            <div class="alert ${alertClass} shadow-sm mt-3 text-center rounded-4 p-4">
              <div class="d-flex align-items-center justify-content-center mb-2">
                <span class="material-symbols-outlined text-primary me-2" style="font-size: 2.5rem;">verified_user</span>
                <h4 class="mb-0 fw-bold">Caso ${idCaso}</h4>
              </div>
              <hr class="opacity-10"/>
              
              <div class="py-2">
                <h5 class="fw-bold text-dark mb-1">${titulo}</h5>
                <p class="small text-muted mb-0">${textoPrincipal}</p>
              </div>

              ${htmlMotivos}

              <div class="bg-white p-3 rounded-4 mt-3 border shadow-xs" style="border-style: dashed !important;">
                <span class="small text-muted text-uppercase fw-bold" style="font-size: 0.7rem;">Estado de tu trámite</span><br/>
                <div class="mt-2">
                  <span class="badge rounded-pill bg-primary px-4 py-2" style="font-size: 0.9rem;">
                    ${estadoVisible}
                  </span>
                </div>
              </div>

              <div class="mt-4 pt-2 border-top">
                <p class="mb-1 small fw-bold text-dark text-center">No es necesario volver a cargar este equipo.</p>
                <p class="mb-0 small text-muted text-center">Te enviaremos la respuesta a tu correo personal a la brevedad.</p>
              </div>
            </div>
          `,
          color: "blue",
        });
        
        setStatus("info_gestion");
        return true;
      }

      // 3. Caso de éxito final
      if (estado === "FINALIZADO" && json.data.codigo) {
        setCodigo(json.data.codigo);
        setStatus("success");
        return true;
      }
    }

    setMensaje({ html: "", color: null });
    return false;
  } catch (err) {
    console.error("Error en checkExisting:", err);
    return false;
  }
};
const onSubmit = async (e) => {
  e.preventDefault();

  // 🔄 limpiar salida previa
  setStatus("idle");
  setCodigo("");
  setMensaje("");
  setHttpStatus(null);
  setDebug(null);

  if (tokenMissing) {
    setStatus("error");
    setMensaje("Falta API token. Configurá la variable VITE_API_TOKEN o pasalo por prop.");
    return;
  }

  if (!validate()) return;

  const hw = sanitizeHWID(hwid);
  const bt = String(bootTick).trim();

  // 🔍 Verificar si el HWID/BT ya existen en la base antes de consultar el servidor nacional
  const alreadyExists = await checkExisting(hw, bt);
  if (alreadyExists) return; // si existe, corta el flujo acá

  try {
    setStatus("loading");
    const res = await fetch(apiUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${apiToken}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ hwid: hw, bootTick: bt }),
    });

    setHttpStatus(res.status);
    const text = await res.text();

    let json;
    try {
      json = JSON.parse(text);
    } catch {
      setStatus("error");
      setMensaje(`Respuesta no JSON del servidor (HTTP ${res.status}).`);
      setDebug(text);
      return;
    }

    setDebug(json);

    // contrato “nuevo” => success boolean
    if (res.ok && typeof json?.success === "boolean") {
      if (json.success) {
        const cod = json.codigo ?? json?.data?.codigo;
        if (cod) {
          setCodigo(String(cod));
          setStatus("success");
          setMensaje("Código obtenido correctamente.");
        } else {
          setStatus("error");
          setMensaje("No se encontró código para los datos provistos.");
        }
      } else {
        setStatus("error");
        setMensaje(pickUiMessage(json, "No pudimos generar el código."));
      }
      return;
    }

    // contrato “viejo” pero HTTP 200
    if (!res.ok) {
      setStatus("error");
      setMensaje(pickUiMessage(json, `Error HTTP ${res.status}`));
      return;
    }

    const cod = json?.data?.codigo ?? json?.codigo ?? "";
    if (cod) {
      setCodigo(String(cod));
      setStatus("success");
      setMensaje("Código obtenido correctamente.");
    } else {
      setStatus("error");
      setMensaje(pickUiMessage(json, "No se encontró código para los datos provistos."));
    }

  } catch (err) {
    setStatus("error");
    setMensaje(`Fallo de red o CORS: ${err?.message || err}`);
  }
};

  const copyCode = async () => {
    try {
      await navigator.clipboard.writeText(codigo);
      setMensaje("Código copiado al portapapeles.");
    } catch {
      setMensaje("No se pudo copiar. Copialo manualmente.");
    }
  };

  // Guarda una “consulta” si no hay código / error
  const guardarConsulta = async (payload) => {
    setSaveStatus("saving");
    setSaving(true);
    setSavedId(null);

    try {
      const res = await fetch("https://pjb.edu.ar/api/desbloqueos_v2/guardar_consulta.php", {
        method: "POST",
        headers: {
          Authorization: `Bearer ${apiToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          hwid: sanitizeHWID(hwid),
          bootTick: String(bootTick).trim(),
          serialNumber: payload?.serialNumber ?? "",
          email:        payload?.email ?? "",
          cue:          payload?.cue ?? "",
          nombre:       payload?.nombre ?? "",
          apellido:     payload?.apellido ?? "",
          jurisdiccion: "CÓRDOBA",
          estado:       "NO_SECRET",
          mensaje:      "El equipo no se encuentra en la base de datos. Contactarse con el equipo de desbloqueos",
          extra:        debug,          // guarda respuesta técnica
          userEmail, userName, userSub, // trazabilidad
        }),
      });

      const j = await res.json().catch(() => ({}));

      if (res.ok && j.ok) {
        setSavedId(j.id);
        setSaveStatus("saved");
        setHttpStatus(null);
        setMensaje(`Consulta registrada (#${j.id}). Te vamos a contactar a la brevedad.`);
      } else {
        setSaveStatus("error");
        setMensaje(j.ui_message || j.msg || `No se pudo guardar (HTTP ${res.status})`);
      }
    } catch (e) {
      setSaveStatus("error");
      setMensaje("Error guardando: " + (e.message || e));
    } finally {
      setSaving(false);
    }
  };


const renderMensaje = (msg, defaultColor = "#000") => {
  if (!msg) return null;
  if (typeof msg === "object" && msg.html) {
    return (
      <div
        style={{ color: msg.color || defaultColor }}
        dangerouslySetInnerHTML={{ __html: msg.html }}
      />
    );
  }
  return <div style={{ color: defaultColor }}>{String(msg)}</div>;
};


  return (
    <div className="container contOption">
      {/* Intro Sponsor */}
      <div className="card mb-4">
        <div className="card-body">
          <h2 className="card-title">Equipos de Nación</h2>

          <div className="row">
            <div className="col-12 mt-3">
              <div className="row">
                <div className="col-1 mt-2 d-flex justify-content-end">
                  <span className="material-symbols-outlined">error</span>
                </div>
                <div className="col-10">
                  <p className="text-warning">
                    <strong>IMPORTANTE:</strong> Mirá el video y luego ingresá los datos que aparecen en pantalla.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-12 d-flex justify-content-center contVideo">
              <iframe
                width="560"
                height="315"
                className="video"
                src={URL_VIDEO_INTRO}
                title="Intro Nación (Sponsor)"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              />
            </div>

            {/* Formulario HWID/BT */}
            <div className="col-12">
              <form className="row g-3 needs-validation mt-3 d-flex justify-content-center" onSubmit={onSubmit} noValidate>
                <div className="col-12 col-lg-8">
                  <div className="input-group has-validation">
                    <span className="input-group-text">Hardware ID</span>
                    <input
                      type="text"
                      className={`form-control ${formError && hwid.trim() === "" ? "is-invalid" : ""}`}
                      value={hwid}
                      onChange={(e) => setHwid(e.target.value)}
                      placeholder="Ej: 0016EBE7128D"
                      required
                      autoComplete="off"
                    />
                    <div className="invalid-feedback">Ingresá el HWID.</div>
                  </div>
                </div>

                <div className="col-12 col-lg-8">
                  <div className="input-group">
                    <span className="input-group-text">Boot Tick</span>
                    <input
                      type="text"
                      className={`form-control ${formError && String(bootTick).trim() === "" ? "is-invalid" : ""}`}
                      value={bootTick}
                      onChange={(e) => setBootTick(e.target.value)}
                      placeholder="Ej: 6"
                      required
                      autoComplete="off"
                    />
                    <div className="invalid-feedback">Ingresá el Boot Tick.</div>
                  </div>
                </div>

                {/* aviso de validación local */}
                {formError && (
                  <div className="col-12 col-lg-8">
                    <div className="alert alert-warning mt-1 mb-0 py-2">{formError}</div>
                  </div>
                )}

                <div className="col-12 col-lg-8 d-flex justify-content-end">
                  <button
                    type="submit"
                    className="btn btn-outline-secondary mt-2 mx-2"
                    disabled={status === "loading" || tokenMissing || !isFormReady}
                  >
                    {status === "loading" ? "Consultando…" : "Continuar"}
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-light mt-2 mx-2"
                    onClick={() => {
                      setHwid(""); setBootTick("");
                      setStatus("idle"); setCodigo(""); setMensaje("");
                      setHttpStatus(null); setDebug(null); setFormError("");
                      setSaveStatus("idle"); setSaving(false); setSavedId(null);
                    }}
                    disabled={status === "loading"}
                  >
                    Limpiar
                  </button>
                </div>

                {tokenMissing && (
                  <div className="col-12 col-lg-8">
                    <div className="alert alert-warning mt-2">
                      <strong>Atención:</strong> Falta API token (VITE_API_TOKEN) para consultar.
                    </div>
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Solución / Error */}
      <div className={`card mb-4 mt-4 ${status === "idle" ? "d-none" : ""}`} id="contSolucion">
        <div className="card-body">
          <div className="row mt-2 mb-2">
            <div className="col-8">
              <h3 className="text-dark">Solución</h3>
            </div>

            {status === "success" ? (
              <>
                {/* Paso 1: código */}
                <div className="col-12" id="contCODIGO">
                  <div className="row">
                    <div className="col-1 mt-2">
                      <span className="material-symbols-outlined">counter_1</span>
                    </div>
                    <div className="col-10">
                      <p className="card-text">
                        En la pantalla de tu computadora bloqueada, presioná la letra <b>y</b>, ingresá el siguiente código y presioná <b>ENTER</b>.
                      </p>
                      <h2 className="card-title text-success text-left">{codigo}</h2>
                      <div className="d-flex justify-content-left mt-3">
                        <button className="btn btn-success" onClick={copyCode}>Copiar código</button>
                      </div>
                        {mensaje && (
                          typeof mensaje === "object" && mensaje.html ? (
                            <p
                              className="text-left mt-2 mb-0"
                              style={{ color: mensaje.color || "#000" }}
                              dangerouslySetInnerHTML={{ __html: mensaje.html }}
                            />
                          ) : (
                            <p className="text-success text-left mt-2 mb-0">
                              {String(mensaje)}
                            </p>
                          )
                        )}


                    </div>
                  </div>
                </div>

                {/* Paso 2 y 3: guía “Sponsor” (agente + servidor) */}
                <div className="col-12" id="contAgente">
                  <div className="row mt-4">
                    <div className="col-1 mt-2">
                      <span className="material-symbols-outlined">counter_2</span>
                    </div>
                    <div className="col-8">
                      <p className="card-text mt-2">Conectate a internet y abrí el AGENTE como se muestra:</p>
                      <img src={imgVerAgente} alt="Ver Agente" className="d-block w-100" />
                    </div>
                  </div>

                  <div className="row mt-4">
                    <div className="col-1 mt-2">
                      <span className="material-symbols-outlined">counter_3</span>
                    </div>
                    <div className="col-8">
                      <p className="card-text mt-2">En la pestaña configuración verificá que el servidor apunte a:</p>
                      <img src={imgServidor} alt="Cambiar servidor" className="d-block w-100" />
                      <p className="text-dark mt-2">URL/Dirección del servidor: <mark>citd.dgp.educ.ar</mark></p>
                    </div>

                    <div className="col-12 mx-3 mt-4">
                      <p className="lead">¿No tenés el programa para cargar los arranques?</p>
                    </div>
                    <div className="col-12 d-flex justify-content-center">
                      <button
                        className="btn btn-outline-primary mb-2"
                        type="button"
                        onClick={() => setShowAgente((s) => !s)}
                      >
                        {showAgente ? "Ocultar" : "Ver video"}
                      </button>
                    </div>

                    <div className="col-10 mt-2 mx-4 mb-4">
                      <div className={`collapse${showAgente ? " show" : ""}`}>
                        <div className="card-body">
                          <div className="video-responsive">
                            <iframe
                              width="560"
                              height="315"
                              src={URL_VIDEO_DESC_AGT}
                              title="Video explicativo de cómo descargar e instalar el agente"
                              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                              allowFullScreen
                            />
                          </div>
                          <a
                            className="btn btn-outline-success mt-3 mb-3"
                            href={Agente}
                            download="ThefClient4.8.exe"
                          >
                            Descargar agente
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : status === "info_gestion" ? (
              /* 🚀 NUEVO BLOQUE: Aquí se muestra el Caso #ID y el estado actual */
              <div className="col-12 p-3">
                {renderMensaje(mensaje)}
                <div className="d-flex justify-content-center mt-3">
                  <button 
                    className="btn btn-outline-secondary" 
                    onClick={() => { setStatus("idle"); setHwid(""); setBootTick(""); }}
                  >
                    Realizar otra consulta
                  </button>
                </div>
              </div>

            ) : status === "loading" ? (
              <div className="col-12 text-center">
                <div className="spinner-border" role="status"><span className="visually-hidden">Loading...</span></div>
                <p className="mb-0 mt-2">Buscando…</p>
              </div>
            ) : status === "error" ? (
              <div className="card-body" id="contError">
                {saveStatus === "saved" ? (
                  <div className="alert alert-success mt-2">
                    <div className="fw-bold">¡Consulta guardada!</div>
                    <div>{mensaje}</div>
                    {savedId && <div className="mt-1">Número de referencia: <b>#{savedId}</b></div>}
                  </div>
                ) : (
                  <>
                    <div className="alert alert-danger mt-2">
                      <div className="text-danger mb-2">No encontramos datos para el HWID/Boot Tick ingresados.</div>
                        {renderMensaje(mensaje, "red") || (
                          <div>Verificá los datos y, si persiste, completá el formulario para que te contactemos.</div>
                        )}

                    </div>

                    <ConsultaForm
                      onGuardar={guardarConsulta}
                      initialEmail={userEmail}
                      initialNombre={nombre || ""}
                      initialApellido={apellido || ""}
                      saving={saving}
                      cueLength={9}
                      serialMin={10}
                      serialMax={24}
                    />
                  </>
                )}
              </div>
            ) : null}
          </div>

          {/* Debug opcional (oculto por defecto) */}
          {debug && (
            <details className="mt-2 d-none">
              <summary>Ver respuesta completa</summary>
              <pre className="mt-2" style={{ whiteSpace: "pre-wrap" }}>
                {JSON.stringify(debug, null, 2)}
              </pre>
            </details>
          )}
        </div>
      </div>
    </div>
  );
}
